import { render, staticRenderFns } from "./AppInicial.vue?vue&type=template&id=78218fb0&"
import script from "./AppInicial.vue?vue&type=script&lang=js&"
export * from "./AppInicial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports